import React from "react";
import {Row, Col, Card, Button} from "react-materialize";
import tools from "../../images/tools.png";
import five_porques from "../../images/FivePorques.png";

import five_Why from '../../images/FiveWhy.png';

import Five_whys_do from '../../components/ferramentas/five_whys_do';

import {Link} from "react-router-dom";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {injectIntl, intlShape} from 'react-intl';

const Five_whys = ({intl}) =>(

    <Card>
        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>

                <div align="center">
                    <img src={tools} className={"img"} alt={"tools image"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"tools.header"} defaultMessage={"Ferramentas"}/></b></p></h5>
            </Col>
        </Row>

        <Row>
            <Col s={2} m={2}>
                {/*Alocando espaço*/}
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"tools.fivewhys.header"} defaultMessage={"5 Porquês"}/></b></p>
                    <p><FormattedMessage id={"fw.text"} defaultMessage={"A técnica dos 5 porquês é simples e serve para identificar a causa raiz de um problema. Consiste em identificar um problema e perguntar pelo menos 5 vezes 'por que'. A resposta ao último por que é a causa raiz do problema. A partir da identificação da causa raíz, é possível descobrir qual ação a ser realizada para reduzir a possibilidade do problema acontecer novamente. A ferramente deve ser utilizada com 'bom-senso', quando perceber que chegou a raiz do problema basta parar."} /> </p>
                </div>
                <br/>
                <p><FormattedMessage id={"example"} defaultMessage={"Exemplo:"}/></p>
            </Col>
        </Row>


        <Row>
            <React.Fragment>
            <div className={"text-center"} align="center">
                {
                    intl.locale=== "en" ?

                        <img src={five_Why} className={"img five whys"} alt={"Five whys"} width={"500"} height={"400"}/>
                        :

                        <img src={five_porques} className={"img"} alt={"5 Porques"} width={"500"} height={"400"}/>


                }
            </div> </React.Fragment>
        </Row>

        <Row classname={"valign-wrapper"}>


            <div align="center">
                <Link to={"/five_whys_do"}>
                    <Button className={"button"}>OK</Button></Link></div>
        </Row>
    </Card>

);

export default injectIntl(Five_whys);